import api from '../../../core/api';
import { deepCopy } from '../../../core/utils/helper';

const ROLE_FORM_DEFAULT = {
  list: [],
  memberInfo: {},
};

export default {
  data () {
    return {
      roleForm: {
        show: false,
        list: [],
        memberInfo: {},
        update_type: 3,
      },
      // 以下两个变量是支撑显示角色名所用的
      roleList: [],
      roleName: {},
    };
  },

  methods: {
    /**
     * 获取所有【系统成员角色】的角色列表
     * @returns {*}
     */
    handleGetRoleList () {
      return api.role.get_all_role({
        usertype: this.userType,
        roletype: this.roletype,
      });
    },
    /**
     * 获取所需的角色列表
     * @author joneshe
     */
    getRoleList () {
      return this.handleGetRoleList().then(res => {
        this.$set(this, 'roleList', res.roles);
        this.dealRoleName(res.roles);
        return res.roles;
      });
    },

    /**
     * 处理角色名称
     * @param list
     */
    dealRoleName (list) {
      const obj = {};
      list.forEach(item => {
        obj[item.RoleId] = item.RoleName;
      });
      this.$set(this, 'roleName', obj);
    },

    addMemberRole (data) {
      this.handleAddMemberRole(data)
        .then(res => {
          this.$toast.success('配置角色成功！');
          this.toggleRoleModal(false);
          this.getUserList(this.modal.affiliation_id);
        })
        .catch(err => {
          this.$toast.error(`接口失败，errcode：${err.errcode}，errmsg：${err.errmsg}`);
        });
    },

    handleAddMemberRole (obj) {
      let updateType;
      // hack处理这个更新类型，
      // 如果是系统内的成员，是已经有该条记录的了，所以执行更新便可
      if (this.sid) {
        updateType = 3;
      }
      else {
        // 不然就根据情况，是1（插入）或者3（更新）
        updateType = this.update_type;
      }
      const data = {
        update_type: updateType,
        updateinfo: [],
      };
      // const sid = localStorage.getItem(config.lsSidName);

      data.updateinfo.push({
        touid: obj.Uid,
        sid: this.sid,
        RoleIds: deepCopy(obj.RoleIds),
      });

      return api.role.update_role_id_by_uid(data);
    },

    getAccountRole (uid) {
      return api.role.get_account_role({
        roletype: this.roletype,
        sid: this.sid,
        uid,
      }).then(res => {
        if (res && res.accrole && res.accrole.length > 0) {
          const roleIds = [];
          res.accrole.forEach(item => {
            if (item.accrole.RoleIds) {
              roleIds.push(item.accrole.RoleIds);
            }
          });
          this.update_type = 3;
          return roleIds.join(',');
        }
        this.update_type = 1;
        return '';
      });
    },

    toggleRoleModal (show, uid) {
      if (show) {
        // 获取用户的权限
        // let promise = this.getRoleByUid(uid);
        let promise = this.getAccountRole(uid);
        let RoleIds;
        // this.$showLoading('获取数据中...');

        // 拉取最新的角色列表
        promise = promise.then(res => {
          RoleIds = res;
          return this.getRoleList();
        });

        promise.then(list => {
          // this.$hideLoading();
          this.$set(this, 'roleForm',
            Object.assign({},
              this.roleForm,
              ROLE_FORM_DEFAULT,
              {
                list,
                show,
                memberInfo: {
                  accrole: {
                    Uid: uid,
                    RoleIds,
                  },
                },
              }));
        });
      }
      else {
        this.roleForm.show = show;
      }
    },

    dealData () {
      this.getRoleList();
    },
  },

  mounted () {
    this.dealData();
  },
};
